// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3wK9m","actionsCol":"EnrolledClinics_actionsCol__1cGns"};